<template>
  <SelectApi endpoint="rma/orders" :itemTitle="title" itemValue="No">
    <template #item="{ item }">
      <VListItem v-bind="item.props" :title="title(item.item.raw)" />
    </template>
    <template #selection="{ item }">
      {{ title(item.item.raw) }}
    </template>
  </SelectApi>
</template>

<script>
export default {
  name: 'SelectRMAOrder',
  methods: {
    title(opt) {
      return `#${opt.No} - ${opt.Order_Date}`;
    }
  }
};
</script>
